import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { ButtonHTMLAttributes } from 'react';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';

import './IconButton.css';

export interface IconButtonProps
  extends Omit<
    ButtonHTMLAttributes<HTMLButtonElement>,
    'children' | 'aria-label'
  > {
  icon: IconProp;
  iconClassName?: string;
  'aria-label'?: string;
  ariaLabel?: string;
}

/**
 * Shared icon-only button used across toolbars and action menus.
 */
const IconButton = ({
  icon,
  iconClassName,
  className,
  type = 'button',
  'aria-label': ariaLabelProp,
  ariaLabel,
  ...rest
}: IconButtonProps) => {
  const buttonClass = ['icon-button', className].filter(Boolean).join(' ');
  const iconClasses = ['icon-button__icon', iconClassName]
    .filter(Boolean)
    .join(' ');
  const computedAriaLabel = ariaLabelProp ?? ariaLabel;

  return (
    <button
      type={type}
      className={buttonClass}
      aria-label={computedAriaLabel}
      {...rest}
    >
      <FontAwesomeIcon icon={icon} className={iconClasses} />
    </button>
  );
};

export default IconButton;
